module.exports = __webpack_public_path__ + "static/media/under-construction.f08fe5b6.svg";